export default __webpack_public_path__ + "static/amsterdam-42f5df3edfdadb820ca1bf916954136a.jpg";